import Vue from 'vue'
import CTooltip from '@convenia/components/CTooltip'

export default ({
  bindingValue,
  isObject,
  align,
  binding,
  el,
  value
}) => {
  const TooltipConstructor = Vue.extend(CTooltip)
  const tooltip = new TooltipConstructor({
    propsData: {
      show: false,
      hide: (bindingValue || {}).hide,
      dark: binding.modifiers.dark,
      fontSize: (isObject && binding.value.fontSize) || 14,
      maxWidth: (isObject && binding.value.maxWidth) || 200,
      horizontalPadding: (isObject && binding.value.horizontalPadding) || 10,
      target: el,
      arrowSpacing: align === 'center' ? 10 : 15,
      elementSpacing: (isObject && binding.value.elementSpacing) || (binding.arg ?? 5),
      position: (isObject && binding.value.position) || 'top',
      isHTML: (isObject && binding.value.isHTML),
      value,
      align
    }
  }).$mount()

  return {
    tooltip,
    setShow: (newValue) => {
      tooltip.show = newValue
    },
    appUnmount: () => {
    }
  }
}
